import React, { useState } from 'react';
import { Alert, AlertIcon, Box, Button, Flex, Text } from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { useActionToast, useFormValidationToast } from '../../../services/actionToast';
import { api } from '../../../services/api';
import { removeAuthStorage } from '../../../services/storage';
import { passwordConfirmationField, passwordField } from '../../../utils/passwordValidation';
import { FormButton } from '../../buttons/FormButton';
import { FormBox } from '../../formBox';
import { FormHeading } from '../../formHeading';
import { PasswordInputForm } from '../../inputs/forms/PasswordInputForm';

const schema = Yup.object().shape({
  current_password: Yup.string().required('Este campo é obrigatório!'),
  new_password: passwordField,
  confirmation: passwordConfirmationField,
});

export default function PasswordManagementForm() {
  const validationToast = useFormValidationToast();
  const toast = useActionToast();
  const navigate = useNavigate();
  const [serverError, setServerError] = useState('');
  const [success, setSuccess] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<any>({
    resolver: yupResolver(schema),
    defaultValues: { current_password: '', new_password: '', confirmation: '' },
  });

  const onSubmit = async (values: any) => {
    setServerError('');
    try {
      await api.post('/auth/change-password', values);
      await removeAuthStorage();
      setSuccess(true);
      toast({
        status: 'success',
        title: 'Senha alterada',
        description: 'Entre novamente para continuar.',
      });
    } catch {
      const feedback =
        'Não foi possível alterar a senha. Verifique a senha atual e tente novamente.';
      setServerError(feedback);
      toast({ status: 'error', title: 'Senha não alterada', description: feedback });
    }
  };

  if (success) {
    return (
      <FormBox>
        <Alert status="success" borderRadius="md" data-testid="change-password-success">
          <AlertIcon />
          <Box>
            <Text fontWeight="bold">Senha alterada com sucesso.</Text>
            <Text>Entre novamente para continuar.</Text>
          </Box>
        </Alert>
        <Button mt={5} colorScheme="orange" onClick={() => navigate('/login', { replace: true })}>
          Ir para o login
        </Button>
      </FormBox>
    );
  }

  return (
    <FormBox>
      <FormHeading>Gerenciar senha</FormHeading>
      <Text mb={5}>A alteração encerra todas as sessões ativas.</Text>
      <form noValidate onSubmit={handleSubmit(onSubmit, validationToast)}>
        <Flex direction="column" gap={3} maxW="620px">
          <PasswordInputForm
            name="current_password"
            label="Senha atual"
            register={register}
            errors={errors}
            isRequired
            autoComplete="current-password"
          />
          <PasswordInputForm
            name="new_password"
            label="Nova senha"
            register={register}
            errors={errors}
            isRequired
            autoComplete="new-password"
          />
          <PasswordInputForm
            name="confirmation"
            label="Confirmar nova senha"
            register={register}
            errors={errors}
            isRequired
            autoComplete="new-password"
          />
          {serverError && (
            <Alert status="error" borderRadius="md" role="alert">
              <AlertIcon />
              {serverError}
            </Alert>
          )}
          <FormButton width="180px" type="submit" isLoading={isSubmitting}>
            Alterar senha
          </FormButton>
        </Flex>
      </form>
    </FormBox>
  );
}
